import { render, staticRenderFns } from "./recapPlayer.vue?vue&type=template&id=b6ea8baa&scoped=true&"
import script from "./recapPlayer.vue?vue&type=script&lang=js&"
export * from "./recapPlayer.vue?vue&type=script&lang=js&"
import style0 from "./recapPlayer.vue?vue&type=style&index=0&id=b6ea8baa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ea8baa",
  null
  
)

export default component.exports